import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const cspFields: FieldInterface[] = [
  {
    key: 'csp',
    originKey: 'csp',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'cspLabel',
    originKey: 'csp_label',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'cspPartnerLabel',
    originKey: 'csp_partner_label',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isMandatory,
  },
  {
    key: 'category',
    originKey: 'category',
    type: FIELD_TYPES.number,
    rule: FIELD_RULES.isMandatory,
    enumKeys: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    key: 'categoryLabel',
    originKey: 'category_label',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
  },
]

const cspRelations: RelationInterface[] = []

export { cspFields, cspRelations }
